import { Component, ElementRef, EventEmitter, HostListener, Inject, Output, Renderer2 } from '@angular/core';
import { DOCUMENT } from '@angular/common';

import { TranslateService } from '@ngx-translate/core';
// import { CookieService } from 'ngx-cookie-service';
import { MenuItem } from './menu.model';
//import { MENU } from './menu'
import { NavigationEnd, Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { LanguageService } from 'src/app/core/services/language.service';
import { changeMode, changelayoutTheme } from 'src/app/store/layouts/layout-action';
import { getLayoutMode } from 'src/app/store/layouts/layout-selector';
import { RootReducerState } from 'src/app/store';
import { Store } from '@ngrx/store';
import { AuthenticationService } from 'src/app/core/services/auth.service';
import { TokenStorageService } from 'src/app/core/services/token-storage.service';
import { TopBarService } from './topbar.service';
import { GlobalComponent } from 'src/app/global-component';

@Component({
  selector: 'app-topbar',
  templateUrl: './topbar.component.html',
  styleUrls: ['./topbar.component.scss']
})
export class TopbarComponent {

  AllmenuItems: MenuItem[] = [];
  isMoreMenu: boolean = false;
  menuItems!: any[];
  navData: any;
  flagvalue: any;
  valueset: any;
  countryName: any;
  cookieValue: any;
  userData: any;
  badgeContent = '4';
  isClassVisible = false;
  isBadgeVisible = true;
  isIdVisible = true;
  toggleDone = false;
  isVisible = true;
  element: any;
  mode: string | undefined;

   backendUrl: string = GlobalComponent.API_URL.replace("/api/", "");

  @Output() mobileMenuButtonClicked = new EventEmitter();
  langChange: any;
  navbarMenuItems: any = [];

  constructor(@Inject(DOCUMENT) private document: any,
    private router: Router,
    public translate: TranslateService,
    private renderer: Renderer2,
    private elementRef: ElementRef,
    private store: Store<RootReducerState>,
    public languageService: LanguageService,
    public authService: AuthenticationService,
    public _cookiesService: CookieService,
    private topBarService: TopBarService) {
    translate.setDefaultLang('en');
  }

  ngOnInit(): void {
    // Menu Items
    //this.menuItems = MENU;
    //this.AllmenuItems = MENU;
    // Initialize the navData and menuItems
    //this.navData = MENU;
    //this.menuItems = this.navData;

    // get user data
    this.userData = this.authService.getLoggedUser();

    // Cookies wise Language set
    this.cookieValue = this._cookiesService.get('lang');
    const val = this.listLang.filter(x => x.lang === this.cookieValue);
    this.countryName = val.map(element => element.text);
    if (val.length === 0) {
      if (this.flagvalue === undefined) { this.valueset = 'assets/images/flags/us.svg'; }
      this.countryName = 'English'
    } else {
      this.flagvalue = val.map(element => element.flag);
    }

    this.topBarService.getMenu().subscribe((data: any) => {
      if (data) {
        this.menuItems = data;
        this.AllmenuItems = data;
        this.navData = data;

        const totalMenus = (data as any[]).filter((item: any) => !item.isTitle).length;
        const layout = totalMenus >= 5 ? 'vertical' : 'horizontal';
        this.store.dispatch(changelayoutTheme({ layout }));
        localStorage.setItem('layoutTheme', layout);
      } else {
        this.router.navigateByUrl('/auth/login');
      }
    });

  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    // if (document.documentElement.clientWidth >= 1025) {
    //   setTimeout(() => {
    //     this.updateMenu(null);
    //   }, 500);
    // }

    if (document.documentElement.clientWidth < 1025 && document.documentElement.getAttribute('data-layout') == 'vertical') {
      document.querySelector(".hamburger-icon")?.classList.add("open");
    } else if (document.documentElement.getAttribute('data-layout') == 'vertical') {
      document.querySelector(".hamburger-icon")?.classList.remove("open");
    }

    setTimeout(() => {
      this.menuPosSetOnClicknHover();
    }, 500);
  }

  /***
  * Activate droup down set
  */
  ngAfterViewInit() {
    // setTimeout(() => {
    //   this.updateMenu('2');
    // }, 1000);

    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.initActiveMenu();
      }
    });
    this.initActiveMenu();

    setTimeout(() => {
      this.menuPosSetOnClicknHover();
    }, 500);
  }

  windowScroll() {
    if (document.body.scrollTop > 100 || document.documentElement.scrollTop > 25) {
      (document.getElementById('back-to-top') as HTMLElement).style.display = "block";
      document.getElementById('page-topbar')?.classList.add('topbar-shadow')
    } else {
      (document.getElementById('back-to-top') as HTMLElement).style.display = "none";
      document.getElementById('page-topbar')?.classList.remove('topbar-shadow')
    }
  }

  /**
  * Fullscreen method
  */
  fullscreen() {
    document.body.classList.toggle('fullscreen-enable');
    if (
      !document.fullscreenElement && !this.element.mozFullScreenElement &&
      !this.element.webkitFullscreenElement) {
      if (this.element.requestFullscreen) {
        this.element.requestFullscreen();
      } else if (this.element.mozRequestFullScreen) {
        /* Firefox */
        this.element.mozRequestFullScreen();
      } else if (this.element.webkitRequestFullscreen) {
        /* Chrome, Safari and Opera */
        this.element.webkitRequestFullscreen();
      } else if (this.element.msRequestFullscreen) {
        /* IE/Edge */
        this.element.msRequestFullscreen();
      }
    } else {
      if (this.document.exitFullscreen) {
        this.document.exitFullscreen();
      } else if (this.document.mozCancelFullScreen) {
        /* Firefox */
        this.document.mozCancelFullScreen();
      } else if (this.document.webkitExitFullscreen) {
        /* Chrome, Safari and Opera */
        this.document.webkitExitFullscreen();
      } else if (this.document.msExitFullscreen) {
        /* IE/Edge */
        this.document.msExitFullscreen();
      }
    }
  }

  topFunction() {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  }

  /***
  * Language Value Set
  */
  // setLanguage(text: string, lang: string, flag: string) {
  //   this.countryName = text;
  //   this.flagvalue = flag;
  //   this.cookieValue = lang;
  //   this.languageService.setLanguage(lang);
  //   setTimeout(() => {
  //     this.navData = MENU;
  //     this.updateMenu('1');
  //   }, 500);
  // }

  /**
  * Toggle the menu bar when having mobile screen
  */
  toggleMobileMenu(event: any) {
    const dataLayout = document.documentElement.getAttribute("data-layout");
    const windowSize = document.documentElement.clientWidth;

    if (dataLayout === "vertical") {
      if (windowSize <= 1025 && windowSize > 767) {
        document.body.classList.add("vertical-sidebar-enable");
        document.documentElement.setAttribute('data-sidebar-size', 'lg')
      } else if (windowSize > 1025) {
        document.body.classList.remove("vertical-sidebar-enable");
        document.documentElement.getAttribute('data-sidebar-size') == 'lg' ? document.documentElement.setAttribute('data-sidebar-size', 'sm-hover') : document.documentElement.setAttribute('data-sidebar-size', 'lg')
      } else if (windowSize <= 767) {
        document.body.classList.add("vertical-sidebar-enable");
        document.documentElement.setAttribute('data-sidebar-size', 'lg')
      }
      document.querySelector(".hamburger-icon")?.classList.toggle("open");
    } else {
      if (windowSize > 767)
        document.querySelector(".hamburger-icon")?.classList.toggle("open");

      //For collapse horizontal menu
      document.body.classList.contains("menu") ? document.body.classList.remove("menu") : document.body.classList.add("menu");
    }
    event.preventDefault();
    this.mobileMenuButtonClicked.emit();
  }
  /**
  * Topbar Light-Dark Mode Change
  */
  changeMode(mode: string) {
    this.mode = mode;
    this.store.dispatch(changeMode({ mode }));
    this.store.select(getLayoutMode).subscribe((mode) => {
      document.documentElement.setAttribute('data-bs-theme', mode)
    })
    if (mode == 'brand') {
      document.documentElement.setAttribute('data-topbar', mode)
    } else {
      document.documentElement.setAttribute('data-topbar', 'dark')
    }

  }

  private menuPosSetOnClicknHover() {
    const isElements = this.elementRef.nativeElement.querySelectorAll("#navbar-nav > li.nav-item");

    Array.from(isElements).forEach((item: any) => {
      setTimeout(() => {
        this.renderer.listen(item, "click", menuItem);
        this.renderer.listen(item, "mouseover", menuItem);
      }, 100);
    });

    const menuItem = (e: any) => {
      const dropdownMenu = e.target;
      const subMenus = dropdownMenu.nextElementSibling || dropdownMenu.parentElement.nextElementSibling;

      if (dropdownMenu && subMenus) {
        const dropdownOffset = subMenus.getBoundingClientRect();
        const dropdownWidth = subMenus.offsetWidth;
        const dropdownHeight = subMenus.offsetHeight;

        const screenWidth = window.innerWidth;
        const screenHeight = window.innerHeight;

        const maxDropdownX = dropdownOffset.left + dropdownWidth;
        const maxDropdownY = dropdownOffset.top + dropdownHeight;

        const isDropdownOffScreen = maxDropdownX > screenWidth;
        const isDropdownOffScreenY = maxDropdownY > screenHeight;

        if (isDropdownOffScreen) {
          if (subMenus.classList.contains("menu-dropdown")) {
            subMenus.classList.add("dropdown-custom-right");
          }
        }
      }
    }
  }

  /***
  * Language Listing
  */
  listLang = [
    { text: 'English', flag: 'assets/images/flags/us.svg', lang: 'en' },
    { text: 'Española', flag: 'assets/images/flags/spain.svg', lang: 'sp' },
    { text: 'Deutsche', flag: 'assets/images/flags/germany.svg', lang: 'gr' },
    { text: 'Italiana', flag: 'assets/images/flags/italy.svg', lang: 'it' },
    { text: 'русский', flag: 'assets/images/flags/russia.svg', lang: 'ru' },
    { text: '中国人', flag: 'assets/images/flags/china.svg', lang: 'ch' },
    { text: 'français', flag: 'assets/images/flags/french.svg', lang: 'fr' },
    { text: 'Arabic', flag: 'assets/images/flags/ae.svg', lang: 'ar' },
  ];

  initActiveMenu() {
    const pathName = window.location.pathname;
    const ul = document.getElementById("navbar-nav");

    if (ul) {
      const items = Array.from(ul.querySelectorAll("a.nav-link"));
      let activeItems = items.filter((x: any) => x.classList.contains("active"));
      this.removeActivation(activeItems);
      let matchingMenuItem = items.find((x: any) => {
        return x.pathname === pathName;
      });
      if (matchingMenuItem) {
        this.activateParentDropdown(matchingMenuItem);
      }
    }
  }

  removeActivation(items: any) {
    items.forEach((item: any) => {
      if (item.classList.contains("menu-link")) {
        if (!item.classList.contains("active")) {
          item.setAttribute("aria-expanded", false);
        }
        (item.nextElementSibling) ? item.nextElementSibling.classList.remove("show") : null;
      }
      if (item.classList.contains("nav-link")) {
        if (item.nextElementSibling) {
          item.nextElementSibling.classList.remove("show");
        }
        item.setAttribute("aria-expanded", false);
      }
      item.classList.remove("active");
    });
  }


  /**
  * Returns true or false if given menu item has child or not
  * @param item menuItem
  */
  hasItems(item: MenuItem) {
    return item.subItems !== undefined ? item.subItems.length > 0 : false;
  }

  updateActive(event: any) {
    const ul = document.getElementById("navbar-nav");

    if (ul) {
      const items = Array.from(ul.querySelectorAll("a.nav-link"));
      this.removeActivation(items);
    }
    this.activateParentDropdown(event.target);
  }

  toggleItem(event: any) {

    let isCurrentMenuId = event.target.closest('a.nav-link');

    let isMenu = isCurrentMenuId.nextElementSibling as any;
    let dropDowns = Array.from(document.querySelectorAll('#navbar-nav .show'));
    (isMenu) ? isMenu.classList.toggle('show') : null;

    const ul = document.getElementById("navbar-nav");
    if (ul) {
      const iconItems = Array.from(ul.getElementsByTagName("a"));
      let activeIconItems = iconItems.filter((x: any) => x.classList.contains("active"));
      activeIconItems.forEach((item: any) => {
        item.setAttribute('aria-expanded', "false")
        item.classList.remove("active");
      });
    }
    if (isCurrentMenuId) {
      this.activateParentDropdown(isCurrentMenuId);
    }
  }

  toggleSubItem(event: any) {

    if (event.target && event.target.nextElementSibling)
      event.target.nextElementSibling.classList.toggle("show");
  };

  // remove active items of two-column-menu
  activateParentDropdown(item: any) { // navbar-nav menu add active
    item.closest('a').classList.add("active");
    let parentCollapseDiv = item.closest(".collapse.menu-dropdown");
    if (parentCollapseDiv) {
      // to set aria expand true remaining
      parentCollapseDiv.classList.add("show");
      parentCollapseDiv.parentElement.children[0].classList.add("active");
      parentCollapseDiv.parentElement.children[0].setAttribute("aria-expanded", "true");
      if (parentCollapseDiv.parentElement.closest(".collapse.menu-dropdown")) {
        parentCollapseDiv.parentElement.closest(".collapse").classList.add("show");
        if (parentCollapseDiv.parentElement.closest(".collapse").previousElementSibling)
          parentCollapseDiv.parentElement.closest(".collapse").previousElementSibling.classList.add("active");
        parentCollapseDiv.parentElement.closest(".collapse").previousElementSibling.setAttribute("aria-expanded", "true");
      }
      return false;
    }
    return false;
  }

  toggleClass() {
    if (!this.toggleDone) {
      this.isClassVisible = !this.isClassVisible;
      this.isIdVisible = !this.isIdVisible;
      this.isBadgeVisible = !this.isBadgeVisible;
      this.badgeContent = this.isBadgeVisible ? '4' : '0';
      this.toggleDone = true;
    }
  }
  toggleMark() {
    if (this.isVisible) {
      const element = document.querySelector('.notification-item'); // Replace 'elementId' with the actual element ID
      if (element) {
        if (this.isVisible) {
          this.renderer.removeClass(element, 'unread-message');
        } else {
          this.renderer.addClass(element, 'unread-message');
        }
        this.isVisible = !this.isVisible;
        this.isVisible = true;
      }
    }
  }
}